import React from "react"
import classnames from "classnames"
import { Section, Content, H2, P, Space, Interactive } from "AtomicComponents"
import { FiftyFiftyBlock } from "AtomicContainers"
import styles from "./MyMazdaVehicleSummary.less"

class MyMazdaVehicleSummary extends React.Component {
  render() {
    const { header, description, bodyStyle, grade, imageUrl, nameplate, rego, vin } = this.props

    return (
      <Section backgroundColor="#F5F5F5" padding>
        <H2 withDetails>{header}</H2>
        <Content xmlString={description} textAlign="center" />
        <FiftyFiftyBlock backgroundColor="#F5F5F5" ratio={60} size="small" imageUrl={imageUrl} imagePosition="right" textAlign="left" textAlignMobile="left" imagePositionMobile>
          <div className={classnames({
            [styles.MyMazdaVehicleSummary]: true
          })}>
            <Interactive>Model</Interactive>
            <P withoutMargin>{nameplate} {grade || ""} {bodyStyle || ""}</P>
            <Space />
            <Interactive>Registration</Interactive>
            <P withoutMargin>{rego || "Contact dealer"}</P>
            <Space />
            <Interactive>VIN</Interactive>
            <P withoutMargin>{vin}</P>
          </div>
        </FiftyFiftyBlock>
      </Section>
    )
  }
}


export default MyMazdaVehicleSummary



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaVehicleSummary/MyMazdaVehicleSummary.jsx